import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  VoucherRequiredDialogComponent,
  VoucherRequiredDialogData,
} from './voucher-required-dialog.component';

/** Single place that opens the "you need an active voucher" dialog, so every call site
 * (dashboard tiles, sidebar nav, the route guard) presents it the same way. */
@Injectable({
  providedIn: 'root',
})
export class VoucherRequiredDialogService {
  constructor(private dialog: MatDialog) {}

  open(data?: VoucherRequiredDialogData) {
    return this.dialog.open(VoucherRequiredDialogComponent, {
      data,
      width: '420px',
      // MatDialog closes every open dialog by default whenever ANY NavigationStart fires. This
      // dialog is opened from inside route guards / navigation click-handlers, where a second,
      // unrelated navigation (e.g. epd.component's skipLocationChange dashboard hop) can start
      // milliseconds later and would otherwise close this dialog before the user ever sees it.
      closeOnNavigation: false,
    });
  }
}
